import { render, staticRenderFns } from "./course-list.vue?vue&type=template&id=0473edff&scoped=true&"
import script from "./course-list.vue?vue&type=script&lang=js&"
export * from "./course-list.vue?vue&type=script&lang=js&"
import style0 from "./course-list.vue?vue&type=style&index=0&id=0473edff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0473edff",
  null
  
)

export default component.exports